import React, {useEffect, useState} from 'react'
import {useDebounce} from "./hooks";
import {cn} from "../../utils/classname";

interface Props {
  autoFocus?: boolean
  defaultValue?: string
  value?: string
  onChange: (value: string) => void
  delay?: number
  fit?: boolean
  cn?: string
}

export default React.memo(function InputControl(props: Props) {
  const {onChange, delay, defaultValue, ...inputProps} = props
  const initValue = defaultValue || ''
  const [value, setValue] = useState(initValue)
  const debouncedValue = useDebounce(value, delay || 1000, false)

  const handleChange = (e) => {
    setValue(e.target.value)
  }

  useEffect(() => {
    if (debouncedValue === initValue) {
      return
    }

    onChange(debouncedValue)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue, initValue])

  const className = cn('e-input e-input-fit', props.cn)

  return (
    <input
      {...inputProps}
      className={className}
      value={value}
      onChange={handleChange}
    />
  )
})
